import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { enCA, enUS, frCA } from 'date-fns/locale';
import DatePicker, { registerLocale } from 'react-datepicker';

import {
  ReactComponent as Calendar,
} from '../../assets/common/calendar.svg';

import i18n from '../../i18n';

import styles from './DatePickerFigo.module.css';

registerLocale('fr-ca', frCA);
registerLocale('en-ca', enCA);
registerLocale('en-us', enUS);

export const DATE_PICKER_TYPE = {
  FULL_DATE: 'full-date',
  MONTH_YEAR: 'month-year',
};

const DatePickerFigo = ({
  classContainer = '',
  maxDate = new Date(),
  minDate = new Date(),
  onDateChange = () => { },
  onBlur = () => { },
  pickerType = DATE_PICKER_TYPE.FULL_DATE,
  selectedDate = null,
  showIcon = true,
}) => {
  const { t } = useTranslation('fileClaimbot');

  const currentLanguage = useMemo(() => (i18n
    .language.toLowerCase()), [i18n.language]);

  const dateFormat = useMemo(() => {
    switch (pickerType) {
      case DATE_PICKER_TYPE.MONTH_YEAR:
        return t('common:dateFormats.monthYear');

      case DATE_PICKER_TYPE.FULL_DATE:
      default:
        return t('common:dateFormats.datePicker');
    }
  }, [t, pickerType]);

  const placeHolderText = useMemo(() => {
    switch (pickerType) {
      case DATE_PICKER_TYPE.MONTH_YEAR:
        return t('common:dateFormats.monthYear');

      case DATE_PICKER_TYPE.FULL_DATE:
      default:
        return t('common:dateFormats.short');
    }
  }, [t, pickerType]);

  return (
    <DatePicker
      className={`${styles.input} ${classContainer}`}
      dateFormat={dateFormat}
      icon={<Calendar className={styles.icon} />}
      locale={currentLanguage}
      maxDate={new Date(maxDate)}
      minDate={new Date(minDate)}
      onBlur={onBlur}
      onChange={onDateChange}
      placeholderText={placeHolderText}
      selected={selectedDate}
      showIcon={showIcon}
      showMonthYearPicker={pickerType === DATE_PICKER_TYPE.MONTH_YEAR}
    />
  );
};

const DatePickerFigoMemo = React.memo(DatePickerFigo);

export { DatePickerFigoMemo as DatePickerFigo };
